var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha } from '@mui/system';
import { blue20, blue50 } from '../../../colors/blue';
import { gray05, gray20opacity40, gray40, gray40opacity40, gray55, gray60, gray80, white, whiteopacity33, } from '../../../colors/gray';
import { neutral40, neutral60opacity10 } from '../../../colors/neutral';
import interBoldFont from '../../../fonts/inter-bold.woff2';
import interItalicFont from '../../../fonts/inter-italic.woff2';
import interLightFont from '../../../fonts/inter-light.woff2';
import interMediumFont from '../../../fonts/inter-medium.woff2';
import interRegularFont from '../../../fonts/inter-regular.woff2';
import interSemiBoldFont from '../../../fonts/inter-semibold.woff2';
import ydsIconFont from '../../../fonts/yds-icon.woff2';
import { rem } from '../../../utils/rem';
import { grid as gridLightStyles } from '../grid/grid';
import { shadows } from '../shadows';
var fonts = "\n    @font-face {\n        font-family: 'Inter';\n        font-style: normal;\n        font-display: fallback;\n        font-weight: 300;\n        src: local('Inter'), url(".concat(interLightFont, ") format('woff2');\n    }\n    @font-face {\n        font-family: 'Inter';\n        font-style: normal;\n        font-display: fallback;\n        font-weight: 400;\n        src: local('Inter'), url(").concat(interRegularFont, ") format('woff2');\n    }\n    @font-face {\n        font-family: 'Inter';\n        font-style: normal;\n        font-display: fallback;\n        font-weight: 500;\n        src: local('Inter'), url(").concat(interMediumFont, ") format('woff2');\n    }\n    @font-face {\n        font-family: 'Inter';\n        font-style: normal;\n        font-display: fallback;\n        font-weight: 600;\n        src: local('Inter'), url(").concat(interSemiBoldFont, ") format('woff2');\n    }\n    @font-face {\n        font-family: 'Inter';\n        font-style: normal;\n        font-display: fallback;\n        font-weight: 700;\n        src: local('Inter'), url(").concat(interBoldFont, ") format('woff2');\n    }\n    @font-face {\n        font-family: 'Inter';\n        font-style: italic;\n        font-display: fallback;\n        font-weight: 400;\n        src: local('Inter'), url(").concat(interItalicFont, ") format('woff2');\n    }\n    @font-face {\n        font-family: 'ydsIcon';\n        font-style: normal;\n        font-display: fallback;\n        font-weight: normal;\n        src: url(").concat(ydsIconFont, ") format('woff2');\n    }\n");
export var MuiCssBaseline = {
    styleOverrides: __assign({ fonts: fonts, 
        /* Firefox scrollbar styles*/
        '*': {
            scrollbarWidth: 'thin',
            scrollbarColor: "".concat(gray40opacity40, " transparent"),
        }, 
        /* Chromium scrollbar styles*/
        '::-webkit-scrollbar': {
            width: rem(12),
            height: rem(12),
            backgroundColor: 'transparent',
            borderRadius: rem(12),
        }, '::-webkit-scrollbar:hover': {
            backgroundColor: neutral60opacity10,
        }, '::-webkit-scrollbar-thumb': {
            backgroundColor: gray40opacity40,
            borderRadius: rem(12),
            backgroundClip: 'padding-box',
            border: "".concat(rem(2), " solid transparent"),
            minWidth: rem(30),
            minHeight: rem(30),
        }, '::-webkit-scrollbar-thumb:hover': {
            backgroundColor: gray40,
        }, '::-webkit-scrollbar-thumb:active': {
            backgroundColor: gray60,
        }, '::-webkit-scrollbar-track': {
            borderRadius: rem(12),
        }, '.YdsSvgIcon-root': {
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0,
            transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            userSelect: 'none',
        }, '.apexcharts-gridline': { stroke: gray20opacity40 }, '.apexcharts-xaxis': { '& line': { stroke: neutral40, strokeWidth: 2 } }, '.apexcharts-xaxis-label': { fill: gray55 }, '.apexcharts-xaxis-tick': { stroke: neutral40 }, '.apexcharts-yaxis': { '& line': { stroke: neutral40 } }, '.apexcharts-yaxis-label': { fill: gray55 }, '.apexcharts-selection-rect': {
            fill: blue20,
            fillOpacity: 0.15,
            stroke: blue50,
            strokeOpacity: 1,
            strokeWidth: 2,
            strokeDasharray: 0,
        }, 
        // Apexcharts tooltip wrapper. Increase specificity to override default styles.
        'div.apexcharts-canvas': {
            '.apexcharts-tooltip, .apexcharts-yaxistooltip, .apexcharts-xaxistooltip': {
                backgroundColor: alpha(gray80, 0.95),
                color: gray05,
                borderRadius: rem(3),
                boxShadow: shadows[4],
            },
        }, 
        // When custom tooltip is not used, style at least markers.
        '.apexcharts-canvas .apexcharts-tooltip-marker': {
            borderRadius: 0,
            '&:before': {
                // Create inner semi-transparent outline.
                content: "''",
                display: 'block',
                width: '100%',
                height: '100%',
                borderWidth: rem(1),
                borderStyle: 'solid',
                borderColor: whiteopacity33,
            },
        }, '.svg_select_points': {
            fill: white,
            stroke: blue50,
            strokeOpacity: 1,
            strokeWidth: 2,
            height: 20,
            width: 6,
            rx: 3,
        } }, gridLightStyles),
};
